import { BasicClient } from '@/utils/httpClient'

export default class Eforms {
  client
  constructor() {
    this.client = new BasicClient()
  }
  token() {
    return this.client.exec('/eforms/token', 'GET')
  }
  validPass(pwd) {
    return this.client.exec('/users/isValidPass', 'POST', { pass: pwd })
  }
  getEforms(hash) {
    return this.client.exec('/eforms', 'POST', { hash })
  }
  signDocument(passphrase, idapp, iddoc, reason, sendDocument, email) {
    return this.client.exec('/documents/sign/', 'PATCH', {
      passphrase,
      idapp,
      iddoc,
      reason,
      sendDocument,
      email
    })
  }
  updateToPending(idapp, iddoc) {
    return this.client.exec(`/documents/pending/${idapp}/${iddoc}`, 'PATCH')
  }
}
